import { IMenu } from '@/types'
import { t } from '@/i18n'

export const exportMenus: IMenu[] = [
  {
    id: 'export-cars',
    name: 'debt',
    path: 'exports/debt/',
  },
  {
    id: 'export-general-cars',
    name: 'general_cars',
    path: 'exports/car-fleet-information/',
  },
  {
    id: 'export-cars-for-sale',
    name: 'cars_for_sale',
    path: 'exports/cars-for-sale/',
  },
  {
    id: 'export-sold-cars',
    name: 'sold_cars',
    path: 'exports/sold-cars/',
  },
  {
    id: 'export-future-payments',
    name: 'future_payments',
    path: 'exports/future-payments/',
  },
  {
    id: 'car_licences',
    name: 'car_licences',
    path: 'exports/car-licences/',
  },
  {
    id: 'rented_cars',
    name: 'rented_cars',
    path: 'exports/rented-cars/',
  },
  {
    id: 'car_licences_file_import',
    name: 'car_licences_file_import',
  },
  {
    id: 'deal_invoices',
    name: 'deal_invoices',
    path: 'exports/deal-invoices/',
  },
  {
    id: 'car_positions',
    name: 'car_positions',
    path: 'exports/car-positions/',
  },
]

export const integrationMenus: IMenu[] = [
  {
    id: 'stream_invoices',
    name: 'stream_invoices',
    path: 'payment/invoice/priority-integration/',
    role: ['admin'],
  },
  {
    id: 'stream_customers',
    name: 'stream_customers',
    path: 'customers/customers/priority-integration/',
    role: ['admin'],
  },
]

export const uploadMenus: IMenu[] = [
  {
    id: 'car_licences_upload',
    name: 'car_licences_file_import',
    path: 'uploads/car-licenses/',
  },
]

export const getMenuSections = () => [
  {
    title: t('exports'),
    sections: [
      {
        title: t('car_reports'),
        items: exportMenus.filter(item => item.path?.includes('car')),
      },
      {
        title: t('financial_reports'),
        items: exportMenus.filter(item => 
          item.path?.includes('payment') || 
          item.path?.includes('debt')
        ),
      },
    ],
  },
  {
    title: t('priority_integration'),
    sections: [
      {
        title: t('invoices'),
        items: integrationMenus.filter(item => item.path?.includes('invoice')),
      },
      {
        title: t('customers'),
        items: integrationMenus.filter(item => item.path?.includes('customers')),
      },
    ],
  },
  {
    title: t('uploads'),
    sections: [
      {
        title: t('car_licences'),
        items: uploadMenus,
      },
    ],
  },
  {
    title: t('invoices'),
    sections: [
      {
        title: t('deal_invoices'),
        items: [
          {
            id: 'deal_invoices',
            name: 'deal_invoices',
            path: 'exports/deal-invoices/',
          },
        ],
      },
      {
        title: t('generate_invoices'),
        items: [
          {
            id: 'send-invoice',
            name: 'send_invoice',
            path: 'payment/invoice/generate/',
            role: ['admin'],
          },
        ],
      },
    ],
  },
  {
    title: t('toll_road'),
    sections: [
      {
        title: t('priority_integration'),
        items: [
          {
            id: 'stream_toll_road_invoices',
            name: 'stream_toll_road_invoices',
            path: 'reports/toll-road/priority-integration/',
            role: ['admin'],
          },
        ],
      },
    ],
  },
] 